export interface QuoteRequest {
  name: string
  company: string
  email: string
  phone: string
  cargo: string
  origin: string
  destination: string
  pickup: string
  temperature: string
  details: string
}

export const QUOTE_RECIPIENT = 'info@holdfasthauling.com'

export function readQuoteRequest(form: HTMLFormElement): QuoteRequest {
  const data = new FormData(form)
  const get = (key: string) => (data.get(key) as string | null)?.trim() ?? ''

  return {
    name: get('name'),
    company: get('company'),
    email: get('email'),
    phone: get('phone'),
    cargo: get('cargo'),
    origin: get('origin'),
    destination: get('destination'),
    pickup: get('pickup'),
    temperature: get('temperature'),
    details: get('details'),
  }
}

export function buildQuoteSubject(quote: QuoteRequest): string {
  const lane = quote.origin && quote.destination ? `${quote.origin} → ${quote.destination}` : 'New lane'
  return `Quote Request — ${quote.name || 'New shipper'} — ${lane}`
}

export function buildQuoteBody(quote: QuoteRequest): string {
  const lines = [
    'New quote request from holdfasthauling.com',
    '',
    `Name: ${quote.name || '—'}`,
    `Company: ${quote.company || '—'}`,
    `Email: ${quote.email || '—'}`,
    `Phone: ${quote.phone || '—'}`,
    '',
    `Cargo type: ${quote.cargo || '—'}`,
    `Origin: ${quote.origin || '—'}`,
    `Destination: ${quote.destination || '—'}`,
    `Pickup date: ${quote.pickup || '—'}`,
    `Temperature requirements: ${quote.temperature || '—'}`,
    '',
    'Additional details:',
    quote.details || '—',
  ]

  return lines.join('\n')
}

export function buildQuoteMailtoUrl(quote: QuoteRequest): string {
  const subject = encodeURIComponent(buildQuoteSubject(quote))
  const body = encodeURIComponent(buildQuoteBody(quote))
  return `mailto:${QUOTE_RECIPIENT}?subject=${subject}&body=${body}`
}
